import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

// ไอคอน ? ท้ายชื่อรายการเงินได้/ค่าลดหย่อน ชี้เมาส์หรือแตะ (มือถือ) แล้วขึ้นคำอธิบายทันที
// ข้อความ hint มาจาก catalog ฝั่ง backend ค่อนข้างยาว เลยขยายกรอบให้กว้างกว่า tooltip ปกติของ bootstrap
export default function HintIcon({ text, placement = "top" }) {
  if (!text) return null;

  return (
    <OverlayTrigger
      placement={placement}
      trigger={["hover", "focus"]}
      delay={{ show: 0, hide: 100 }}
      overlay={
        <Tooltip style={{ "--bs-tooltip-max-width": "320px", "--bs-tooltip-opacity": 1 }}>
          <div className="text-start" style={{ lineHeight: 1.5, padding: "2px 2px" }}>{text}</div>
        </Tooltip>
      }
    >
      <span
        role="button"
        tabIndex={0}
        className="d-inline-flex align-items-center ms-2 text-secondary"
        style={{ cursor: "help", outline: "none" }}
        aria-label={text}
      >
        <i className="fa-solid fa-circle-question" style={{ fontSize: "0.8rem" }} />
      </span>
    </OverlayTrigger>
  );
}
